import React from 'react';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';

const TodoDialogSideItem = ({ item, toggleField, visibleFields }) => {
  const { values } = useFormikContext();
  return (
    <Box
      onClick={() => toggleField(item.key, values)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer',
        color: visibleFields[item.key] ? '#9ca3af' : '#60a5fa',
        fontWeight: 600,
        p: 1,
        borderRadius: 1,
        backgroundColor: visibleFields[item.key] ? 'rgba(173, 178, 184, 0.15)' : 'transparent',
        '&:hover': {
          backgroundColor: 'rgba(96, 165, 250, 0.12)',
        },
      }}
    >
      {item.icon}
      {item.label}
    </Box>
  );
};

export default TodoDialogSideItem;
